/**
 * Persist the user's selected utility across Utility Planning pages.
 * We keep this intentionally small and resilient to bad/old storage values.
 */
export const UTILITY_SELECTION_STORAGE_KEY = 'gridplan.utilitySelection.v1';

export function setSelectedUtility(selection) {
  try {
    if (typeof window === 'undefined') return;
    if (!selection || typeof selection !== 'object') return;
    const stateCode = typeof selection.stateCode === 'string' ? selection.stateCode : '';
    const utilityName = typeof selection.utilityName === 'string' ? selection.utilityName : '';
    const rawTerritoryId = selection.utilityTerritoryId;
    const utilityTerritoryId =
      typeof rawTerritoryId === 'number'
        ? rawTerritoryId
        : (typeof rawTerritoryId === 'string' && rawTerritoryId.trim() ? rawTerritoryId.trim() : null);
    window.localStorage.setItem(
      UTILITY_SELECTION_STORAGE_KEY,
      JSON.stringify({ stateCode, utilityName, utilityTerritoryId })
    );
  } catch {
    // ignore storage errors (private mode, quotas, etc.)
  }
}

export function getSelectedUtility() {
  try {
    if (typeof window === 'undefined') return null;
    const raw = window.localStorage.getItem(UTILITY_SELECTION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const stateCode = typeof parsed.stateCode === 'string' ? parsed.stateCode : '';
    const utilityName = typeof parsed.utilityName === 'string' ? parsed.utilityName : '';
    const utilityTerritoryId =
      typeof parsed.utilityTerritoryId === 'number'
        ? parsed.utilityTerritoryId
        : (typeof parsed.utilityTerritoryId === 'string' && parsed.utilityTerritoryId.trim()
            ? parsed.utilityTerritoryId.trim()
            : null);
    if (!stateCode && !utilityName) return null;
    return { stateCode, utilityName, utilityTerritoryId };
  } catch {
    return null;
  }
}

export function clearSelectedUtility() {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(UTILITY_SELECTION_STORAGE_KEY);
  } catch {
    // ignore
  }
}

